// eslint-disable-next-line max-len

import axios, { AxiosResponse, AxiosError } from 'axios';

export function createApiClient() {
  const api = axios.create({
  });

  api.interceptors.response.use(
    (response: AxiosResponse) => response.data,
    (error: AxiosError) => {
      const apiError = new Error('An error occurred while processing your request.');
      if (error.response) {
        if (error.response.status === 500) {
          apiError.message = 'Your request cannot be submitted at this time. Please save and try again later.';
        } else if (typeof error.response.data === 'object' && error.response.data !== null) {
          if ('message' in error.response.data) {
            apiError.message = error.response.data.message as string || 'An error occurred.';
          } else {
            apiError.message = 'An error occured';
          }
        }

        apiError.name = error.response.status.toString();
      } else if (error.request) {
        apiError.message = 'No response received from the server.';
      } else {
        apiError.message = 'An error occurred while processing your request.';
      }

      return Promise.reject(apiError.message);
    },
  );

  return api;
}

export default createApiClient();
